import { CriteoTracker, criteoEvent, ID } from "../../types";
import { encryptSha256 } from "../../utils/encryptSha256";
import { ACCOUNT_ID, siteType, HASH_METHOD } from "./constants";

export const createTracker = (email?: string): CriteoTracker[] => {
  const tracker: CriteoTracker[] = [
    { event: criteoEvent.setAccount, account: ACCOUNT_ID },
    { event: criteoEvent.setSiteType, type: siteType.mobile },
  ];
  if (email) {
    tracker.push({
      event: criteoEvent.setEmail,
      email: encryptSha256(email),
      hash_method: HASH_METHOD,
    });
  }
  return tracker;
};

export interface ItemInfo {
  id: ID;
}

export interface BasketInfo extends ItemInfo {
  price: number;
}

export interface OrderInfo {
  id: number | string | string[];
  item: BasketInfo;
}
